"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupMultiplex = exports.jsonStringifyStream = exports.jsonParseStream = void 0;
var _through = _interopRequireDefault(require("through2"));
var _objMultiplex = _interopRequireDefault(require("obj-multiplex"));
var _pump = _interopRequireDefault(require("pump"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Returns a stream transform that parses JSON strings passing through
 * @return {stream.Transform}
 */
var jsonParseStream = function jsonParseStream() {
  return _through.default.obj(function (serialized, _, cb) {
    this.push(JSON.parse(serialized));
    cb();
  });
};
/**
 * Returns a stream transform that calls {@code JSON.stringify}
 * on objects passing through
 * @return {stream.Transform} the stream transform
 */

exports.jsonParseStream = jsonParseStream;
var jsonStringifyStream = function jsonStringifyStream() {
  return _through.default.obj(function (obj, _, cb) {
    this.push(JSON.stringify(obj));
    cb();
  });
};
/**
 * Sets up stream multiplexing for the given stream
 * @param {any} connectionStream - the stream to mux
 * @return {stream.Stream} the multiplexed stream
 */

exports.jsonStringifyStream = jsonStringifyStream;
var setupMultiplex = function setupMultiplex(connectionStream) {
  var mux = new _objMultiplex.default(); // bind helper method to get previously created streams

  mux.getStream = function (name) {
    if (this._substreams[name]) {
      return this._substreams[name];
    } else {
      return this.createStream(name);
    }
  };
  (0, _pump.default)(connectionStream, mux, connectionStream, function (err) {
    if (err) console.error(err);
  });
  return mux;
};
exports.setupMultiplex = setupMultiplex;